import { DEFAULT_LOCALE } from './currency-format';
export function dateFormat({ locale = DEFAULT_LOCALE }) {
    const Intl = typeof window === 'undefined' ? null : window.Intl;
    return Intl
        ? new Intl.DateTimeFormat(locale.replace('_', '-'), {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        }).format
        : fallback;
}
const fallback = (date) => new Date(date).toLocaleDateString();
const isUtcBeforeFix = (utcDate) => utcDate.getUTCHours() !== 0 ||
    utcDate.getUTCMinutes() !== 0 ||
    utcDate.getUTCSeconds() !== 0;
export const localDate = (formatter) => (utcDate) => isUtcBeforeFix(utcDate)
    ? formatter(utcDate)
    : formatter(new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate()));
//# sourceMappingURL=date-format.js.map